import React, { useEffect, useState } from 'react';
import BackToTopButton from '../components/BackToTopButton'

function Home() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 100); // Delay to apply the active class after the component mounts

    return () => clearTimeout(timer); // Clean up timer on component unmount
  }, []);

  return (
    <div className="relative">
      {/* Hero Section with Fade-in Effect */}
      <section
        className={`bg-gradient-to-r from-gray-900 to-black h-screen flex flex-col justify-center items-center text-center text-white fade-in ${isVisible ? 'fade-in-active' : ''}`}
      >
        <div className="container mx-auto px-4">
          <h1 className="text-6xl font-bold mb-6">
            Welcome to CrossTax Advisors
          </h1>
          <p className="text-xl text-gray-300 mb-8 max-w-2xl mx-auto">
            Experience seamless, cross-border tax solutions tailored for US-India needs. We simplify complex tax requirements with precision and expertise.
          </p>
          <button className="btn-primary px-8 py-3 bg-accent text-white font-semibold rounded-full hover:bg-blue-600 hover:scale-105 hover:shadow-lg transition transform duration-300">
            Discover Our Services
          </button>
        </div>

        {/* Scrolling Arrow */}
        <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 animate-bounce">
          <a href="#intro-section">
            <i className="fas fa-chevron-down text-white text-2xl"></i>
          </a>
        </div>
      </section>

      {/* Introduction Section */}
      <section id="intro-section" className="bg-gray-100 py-16">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-semibold text-gray-900 mb-4">Your Trusted Partner in US-India Tax Solutions</h2>
          <p className="text-lg text-gray-700 max-w-3xl mx-auto mb-10">
            At CrossTax Advisors, we specialize in US-India cross-border tax advisory, bringing clarity and precision to complex tax matters. Our goal is to provide tailored solutions for individuals and businesses navigating dual-country tax requirements.
          </p>
        </div>
      </section>

      {/* Key Benefits Section */}
      <section className="bg-gray-50 py-12">
        <div className="container mx-auto px-4 grid grid-cols-1 md:grid-cols-3 gap-6 text-center">
          <div>
            <i className="fas fa-globe text-3xl text-accent mb-4"></i>
            <h4 className="font-semibold text-lg text-gray-900">US-India Expertise</h4>
            <p className="text-gray-600">In-depth knowledge of cross-border tax regulations.</p>
          </div>
          <div>
            <i className="fas fa-handshake text-3xl text-accent mb-4"></i>
            <h4 className="font-semibold text-lg text-gray-900">Customized Solutions</h4>
            <p className="text-gray-600">Flexible service models to meet unique client needs.</p>
          </div>
          <div>
            <i className="fas fa-shield-alt text-3xl text-accent mb-4"></i>
            <h4 className="font-semibold text-lg text-gray-900">Trusted Advisors</h4>
            <p className="text-gray-600">Reliable support from certified tax professionals.</p>
          </div>
        </div>
      </section>
      <BackToTopButton />
    </div>
  );
}

export default Home;
